module.exports = __webpack_public_path__ + "img/analytic_uprock.b9bacc29.svg";